export const generateRescheduleCQL = (externalEventId: string) => {
  return `(update_events (find_events (event_id "${externalEventId}")) (event_mutation (when (date_merge (nearby)))))`;
};

export const generateRescheduleDurationAndFindMoreTimesCQL = (
  externalEventId: string,
  durationInMinutes: number,
) => {
  return `(update_events (find_events (event_id "${externalEventId}")) (event_mutation (duration (delta (minute ${durationInMinutes}))) (when (date_merge (nearby)))))`;
};

export const generateRescheduleDurationAtExactTimeCQL = (
  externalEventId: string,
  durationInMinutes: number,
) => {
  return `(update_events (find_events (event_id "${externalEventId}")) (event_mutation (duration (delta (minute ${durationInMinutes})))))`;
};

export const generateScheduleCQL = (calendarIds: string[]) => {
  const attendeeesString = calendarIds.map((calendarId) => `"${calendarId}"`).join(" ");
  return `(create_event (attendees ${attendeeesString}))`;
};
